import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function ErrorAlert() {
    const title = t({
        message: 'Something went wrong',
        comment: 'teams table: error alert title',
    });
    const message = t({
        message: 'We cant load teams right now. Please try again later.',
        comment: 'teams table: error alert message',
    });
    return <Alert title={title} message={message} appearance="danger"/>;
}
